import styled from 'styled-components';
import React from 'react';
import { Button, SectionParent } from '../../StyledComponents';
// import Arrow from '../../../assets/v2/homepagedevsection/arrow.svg';
// import DeveloperHero from '../../../assets/v2/png/developer_hero.svg';
import Cloud from './Cloud';
import Android from './Android';

const Tab = styled.div`
  box-shadow: 0px 2px 4px 0px #08102b;
  position: sticky;
  top: 72px;
  z-index: 30;
  text-align: center;
  background-color: #131f44;
  max-height: 100px;
  border: none;
  @media (max-width: 520px) {
    display: block;
    height: 92px;
    width: 100%;
    top: 70px;
  }
  @media (max-width: 1367px) and (min-width: 521px) {
    top: 90px;
  }
  @media (max-width: 375px) {
    top: 65px;
  }
  @media (max-width: 320px) {
    top: 55px;
  }
  @media (min-width: 1500px) {
    top: 85px;
  }
`;

const TabButton = styled(Button)`
  display: inline-block;
  background-color: #131f44;
  min-height: 90px;
  margin-top: 0px;
  margin-bottom: 0px;
  border-radius: 0px;
  width: 400px;
  @media (max-width: 520px) {
    width: 48%;
    font-size: 18px !important;
    display: table-cell;
    margin-left: 0px;
    margin-right: 0px;
  }
  @media (max-width: 400px) {
    font-size: 16px !important;
  }
  @media (max-width: 360px) {
    font-size: 13px !important;
  }
`;

const Divider = styled.div`
  background-image: linear-gradient(to top, #18285d, #0f1a3e);
  height: 100px;
  @media (max-width: 1980px) {
    margin-left: -5rem;
    margin-right: -5rem;
  }
  @media (min-width: 1501px) {
    margin-left: -10rem;
    margin-right: -10rem;
    height: 110px;
  }
  @media (max-width: 520px) {
    margin-left: -1rem;
    margin-right: -1rem;
    height: 100px;
  }
`;

const TabButtonAndroid = styled(Button)`
  display: inline-block;
  background-color: #131f44;
  min-height: 90px;
  margin-top: 1px;
  margin-bottom: 0px;
  border-radius: 0px;
  width: 400px;
  @media (max-width: 520px) {
    width: 48%;
    font-size: 18px !important;
    display: table-cell;
    margin-left: 0px;
    position: relative;
    bottom: 11px;
  }
  @media (max-width: 400px) {
    font-size: 16px !important;
    display: table-cell;
    margin-left: 0px;
    position: relative;
    bottom: 9px;
  }
  @media (max-width: 360px) {
    font-size: 13px !important;
    display: table-cell;
    margin-left: 0px;
    position: relative;
    bottom: 7.1px;
  }
`;

const TabContentWrapper = styled.div`
  display: block;
`;

const Section = styled(SectionParent)`
  display: grid;
  /* padding-top: 5rem !important; */
  position: relative;
  z-index: 0;
  padding-bottom: 0rem !important;
  display: grid;
  /* padding: 0rem 25rem; */
  /* grid-template-columns: repeat(14, 1fr); */
  background: #0f1a3e;
`;

export class DeveloperSectionTwo extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      tab: 'android',
      width: 0,
      height: 0,
      first: true,
      divPos: 0,
      mobScr: 0,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    this.handleScroll();
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener('scroll', this.handleScroll);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  handleScroll = () => {
    const divPos = document.getElementById('divider')?.offsetTop;
    this.setState({
      divPos,
      mobScr: window.scrollY,
    });
    if (this.state.width > 1600 && divPos !== undefined) {
      if (window.scrollY >= divPos + 500) {
        this.setState(
          {
            tab: 'cloud',
          },
          () => console.log(this.state.tab)
        );
      } else if (window.scrollY < divPos + 500) {
        this.setState(
          {
            tab: 'android',
          },
          () => console.log(this.state.tab)
        );
      }
    } else if (this.state.width > 1300 && divPos !== undefined) {
      if (window.scrollY >= divPos + 500) {
        this.setState(
          {
            tab: 'cloud',
          },
          () => console.log(this.state.tab)
        );
      } else if (window.scrollY < divPos + 500) {
        this.setState(
          {
            tab: 'android',
          },
          () => console.log(this.state.tab)
        );
      }
    } else if (this.state.width < 520 && divPos !== undefined) {
      if (window.scrollY >= divPos + 500) {
        this.setState(
          {
            tab: 'cloud',
          },
          () => console.log(this.state.tab)
        );
      } else if (window.scrollY < divPos + 500) {
        this.setState(
          {
            tab: 'android',
          },
          () => console.log(this.state.tab)
        );
      }
    }
  };

  changeTab = (name: string) => {
    this.setState(
      {
        tab: name,
      },
      () => {
        document.body.style.backgroundColor = '#0f1a3e';
        if (this.state.tab === 'android') {
          if (this.state.width > 1500) {
            window.scrollTo({
              top: 1120,
              behavior: 'smooth',
            });
          } else if (this.state.width > 1300) {
            window.scrollTo({
              top: 1020,
              behavior: 'smooth',
            });
          } else if (this.state.width < 520) {
            window.scrollTo({
              top: 750,
              behavior: 'smooth',
            });
          }
        } else if (this.state.tab === 'cloud') {
          const element = document.getElementById('divider');
          element?.scrollIntoView({
            behavior: 'smooth',
          });
        }
      }
    );
  };

  render() {
    return (
      <>
        <Tab
          style={
            this.state.width < 520 &&
            this.state.mobScr > this.state.divPos + 3000
              ? {
                  position: 'relative',
                  zIndex: 'unset',
                  top: '0',
                }
              : {}
          }
        >
          <TabButtonAndroid
            className="tablinks"
            id="defaultOpen"
            onClick={() => this.changeTab('android')}
            style={
              this.state.tab === 'android'
                ? {
                    color: '#66d1b1',
                    fontSize: '22px',
                    fontWeight: 'bold',
                    backgroundColor: '#0f1a3e',
                    borderBottom: 'solid 3px #66d1b1',
                  }
                : {
                    fontSize: '22px',
                    fontWeight: 'normal',
                  }
            }
          >
            Android Development Tools
          </TabButtonAndroid>
          <TabButton
            className="tablinks"
            onClick={() => this.changeTab('cloud')}
            style={
              this.state.tab === 'cloud'
                ? {
                    color: '#66d1b1',
                    fontSize: '22px',
                    fontWeight: 'bold',
                    backgroundColor: '#0f1a3e',
                    borderBottom: 'solid 3px #66d1b1',
                  }
                : {
                    fontSize: '22px',
                    fontWeight: 'normal',
                  }
            }
          >
            Cloud Tools
          </TabButton>
        </Tab>
        <Section id="section">
          <TabContentWrapper id="android" className="tabcontent">
            <Android />
          </TabContentWrapper>
          <Divider id="divider" />
          <TabContentWrapper id="cloud" className="tabcontent">
            <Cloud />
          </TabContentWrapper>
        </Section>
      </>
    );
  }
}

export default DeveloperSectionTwo;
